import { useNavigate, useParams } from "react-router-dom";
import GoogleMapReact from 'google-map-react';
import moment from "moment";
import { useEffect, useState } from "react";
import { useGetCollectionWard_DataQuery } from "./CollectionWardSlice";


const DEFAULT_CENTER = { lat: 26.9041268, lng: 75.7846981 };
// const DEFAULT_ZOOM = 10;
// const MAP_API_KEY = 'AIzaSyBqbSNw8jtcU9MjyqXFgKdP9l9UeWqaTz8';
const MAP_API_KEY = 'AIzaSyB0odnoi2ib7N0eNxE2GWwf9xe_aC87PZI';

const CollectionWard_Data = () => {
    const [DEFAULT_ZOOM, setDEFAULT_ZOOM] = useState(13)
    const [mapCenter, setMapCenter] = useState(DEFAULT_CENTER);
    const [mapInstance, setMapInstance] = useState(null);
    const [googleMaps, setGoogleMaps] = useState(null);
    const { time, ward } = useParams();
    const [tripLocationDataPath, setTripLocationDataPath] = useState([]);
    const [geoPath, setGeoPath] = useState([]);

    const {
        data: collectionWard_Data
    } = useGetCollectionWard_DataQuery({ time, ward })

    console.log("collectionWard_Data", collectionWard_Data);

    useEffect(() => {
        const assignmentIds = collectionWard_Data?.map(item => item.assignment_id);
        const fetchData = async (assignment) => {
            try {
                const response = await fetch(`https://apis.ecowrap.in/b2g/eco-admin/travelled-path-app/?assignment_id=${assignment}`, {
                    headers: {
                        authorization: `Bearer ${(localStorage.getItem("tokenAdminPanel"))}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response?.json();
                setTripLocationDataPath(prev => [...prev, result?.data]);

            } catch (error) {
                console.log('error', error);
            }
        };
        for (let index = 0; index < assignmentIds?.length; index++) {
            fetchData(assignmentIds[index]);
        }
    }, [collectionWard_Data]);


    useEffect(() => {
        const geo = collectionWard_Data?.map(item => item.geo_id);
        const fetchData = async (geo) => {
            try {
                const response = await fetch(`https://apis.ecowrap.in/b2g/eco-admin/geo-fence?geo_id=${geo}`, {
                    headers: {
                        authorization: `Bearer ${(localStorage.getItem("tokenAdminPanel"))}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response?.json();
                setGeoPath(prev => [...prev, result?.data])

            } catch (error) {
                console.log('error', error);
            }
        };
        for (let index = 0; index < geo?.length; index++) {
            fetchData(geo[index]);
        }
    }, [collectionWard_Data]);

    useEffect(() => {
        const polygons = [];
        const polylines = [];

        if (mapInstance && googleMaps) {
            const polylineCoordinates = geoPath.map((item) => {
                return item[0]?.boundry[0]?.map((cord) => ({
                    lat: cord?.x,
                    lng: cord?.y,
                }));
            });
            polylineCoordinates.map((arr) => {
                const polyline = new googleMaps.Polyline({
                    path: arr,
                    strokeColor: '#808080',
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                });

                polyline.setMap(mapInstance);
                polylines.push(polyline);
            })
        }

        // Cleanup function to remove polygons and polylines
        return () => {
            polygons.forEach((polygon) => {
                polygon.setMap(null);
            });

            polylines.forEach((polyline) => {
                polyline.setMap(null);
            });
        };
    }, [geoPath, mapInstance, googleMaps]);

    useEffect(() => {
        const polygons = [];
        const polylines = [];

        if (mapInstance && googleMaps) {

            const polylineCoordinates = tripLocationDataPath.map((item) => {
                return item?.map((cord) => ({
                    lat: cord?.location?.x,
                    lng: cord?.location?.y,
                }));
            });
            polylineCoordinates.map((arr) => {
                const polyline = new googleMaps.Polyline({
                    path: arr,
                    strokeColor: '#53AF5C',
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                });

                polyline.setMap(mapInstance);
                polylines.push(polyline);
            })
        }

        // Cleanup function to remove polygons and polylines
        return () => {
            polygons.forEach((polygon) => {
                polygon.setMap(null);
            });

            polylines.forEach((polyline) => {
                polyline.setMap(null);
            });
        };
    }, [tripLocationDataPath, mapInstance, googleMaps]);
    return (
        <>
            <div className="container-fluid p-3">
                <div className="row d-flex justify-content-between p-1">
                    <h4 className="col-5 heading_CollectionBox">Collection Ward</h4>
                </div>
                {collectionWard_Data?.map((e) => {
                    return <div className="list_Box row border m-auto shadow-sm d-flex p-4 rounded mt-4">
                        <p className="col-5 list_CollectionBox">{`Area: ${e?.area_name} ${e?.tag}`}</p>
                        {/* <p className="col-5 list_CollectionBox">{`Collection Date: ${moment(e?.collection_date).format('YYYY-MM-DD')}`}</p> */}
                        <p className="col-5 list_CollectionBox">{`Driver Name: ${e?.piolet_name}`}</p>
                        <p className="col-5 list_CollectionBox">{`Driver Number: ${e?.piolet_number}`}</p>
                        {/* <p className="col-5 list_CollectionBox">{`Started at: ${moment(e?.start_time).format('YYYY-MM-DD | hh:mm')}`}</p> */}
                        <p className="col-5 list_CollectionBox">{`Started at: ${e?.start_time ? new Date(e?.start_time).toISOString().slice(0, 19).replace('T', ' ') : 'Invalid date'}`}</p>
                        {/* <p className="col-5 list_CollectionBox">{`Completed at: ${moment(e?.end_time).format('YYYY-MM-DD | hh:mm')}`}</p> */}
                        <p className="col-5 list_CollectionBox">{`Completed at: ${e?.end_time ? new Date(e?.end_time).toISOString().slice(0, 19).replace('T', ' ') : 'Invalid date'}`}</p>
                        <p className="col-5 list_CollectionBox">{`Status: ${e?.status}`}</p>
                        <p className="col-5 list_CollectionBox">{`Supervisor Name: ${e?.supervisor_name}`}</p>
                        <p className="col-5 list_CollectionBox">{`Supervisor Number: ${e?.supervisor_number}`}</p>
                        {/* <p className="col-5 list_CollectionBox">{`Area: ${e?.area_name}  ${" " + e?.tag}`}</p> */}
                        {/* <p className="col-5 list_CollectionBox">{`Vehicle Name: ${e?.vehicle_name}`}</p> */}
                        <p className="col-5 list_CollectionBox">{`Vehicle Number: ${e?.vehicle_number}`}</p>
                    </div>
                })}

                <div className="col-md-12" style={{ height: '67vh', width: '100%', position: 'relative' }}>
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: MAP_API_KEY }}
                        defaultCenter={DEFAULT_CENTER}
                        defaultZoom={1}
                        yesIWantToUseGoogleMapApiInternals
                        center={mapCenter}
                        zoom={DEFAULT_ZOOM}
                        onGoogleApiLoaded={({ map, maps }) => {
                            setMapInstance(map);
                            setGoogleMaps(maps);
                        }}
                    >
                    </GoogleMapReact>
                </div>
            </div>

        </>
    )
}

export default CollectionWard_Data;